import React from 'react'
import { Global } from '@emotion/core'

export default () =>
  <Global
    styles={() => ({
      body: {
        color: 'white',
        backgroundColor: '#0063A6'
      }
    })}
  />
